/* boscer-addons.js — "Maak je installatie compleet": accessoire toevoegen zonder de pagina te verlaten.
 *
 * Sten 25-09-2026: het blok staat nu ook in de zijlade (mini-cart), naar voorbeeld van Artin.
 * Die zijlade wordt door het thema opnieuw opgebouwd na elke wijziging, dus knoppen worden via
 * een klik-luisteraar op het document afgehandeld in plaats van per knop. Na het toevoegen laat
 * de knop kort een vinkje zien en vraagt dan het thema de winkelwagen te verversen
 * (event "cart:refresh"); herladen van de hele pagina is niet meer nodig.
 */
(function () {
  'use strict';
  if (window.__boscerAddons) return;
  window.__boscerAddons = true;

  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function zetKlaar(knop) {
    knop.classList.add('boscer-addon__knop--klaar');
    var icoon = knop.querySelector('.boscer-addon__knop-icoon');
    var label = knop.querySelector('.boscer-addon__knop-label');
    if (icoon) icoon.textContent = '✓';
    if (label) label.textContent = 'Toegevoegd';
  }

  function verversWinkelwagen() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  }

  function tellerBijwerken() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count],.cart__count,.cart-count,.header__cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* Het thema zet het getal bij het winkelmandje na een verversing niet goed (het leest een
     attribuut dat in het antwoord niet op de plek staat waar het zoekt). Na elke verversing
     halen we daarom het echte aantal op. "cart:rerendered" bubbelt niet, dus luisteren in de
     capture-fase. */
  document.addEventListener('cart:rerendered', tellerBijwerken, true);

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('.boscer-addon__knop');
    if (!knop || knop.disabled) return;
    e.preventDefault();

    var variantId = parseInt(knop.dataset.variantId, 10);
    var inCart = knop.dataset.inCart === 'true';
    knop.disabled = true;
    knop.classList.add('boscer-addon__knop--bezig');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        knop.classList.remove('boscer-addon__knop--bezig');
        if (data.status) {
          knop.disabled = false;
          console.warn('boscer-addons: toevoegen mislukt', data.description);
          return;
        }
        zetKlaar(knop);
        if (inCart) {
          /* Even het vinkje laten zien, dan ververst het thema de winkelwagen: het accessoire
             staat dan bij de artikelen en verdwijnt uit dit blok. */
          setTimeout(verversWinkelwagen, rustig ? 0 : 650);
        } else {
          tellerBijwerken();
        }
      })
      .catch(function () {
        knop.classList.remove('boscer-addon__knop--bezig');
        knop.disabled = false;
      });
  });
})();
